<template>
	<div class="">
		<div class="order_tabs">
			<template v-for="(itme,i) in tabs" >
				<div  :key="i" class="tab " :class="{'tab_cho':index==i}" @click="addmi(i)">{{itme}}</div>
				<span :key="'F'+i" v-if="tabs.length-1 != i">|</span>
			</template>
		</div>
		<div v-loading="loading">
			<div v-if="integralList.length">
				<div class="order_to">
					<span>商品信息</span>
					<span>总积分</span>
					<span>交易状态</span>
				</div>
				<div class="order_zi" v-for="item in integralList" :key="item.id">
					<div class="zi_to">
						<span>{{item.create_time}}</span>
						<span>订单号:{{item.out_trade_no}}</span>
					</div>
					<div class="zi_box">
						<div class="zi_download">
							<img :src="item.goods_images">
							<div class="zi_name">
								<div>{{item.goods_name}}</div>
								<div @click="xin.goUrl('/integral')" class="lan">积分兑换</div>
							</div>
						</div>
						<div class="jine">{{item.total_integral}}</div>
						<div class="zi_btn">
							<div>{{item.status|integralS}}</div>
							<div class="lan" @click="xin.goUrl('/IntegralDetails?gid='+item.id)">查看订单</div>
							<button v-preventReClick class="lan" @click="Postintegralcancel(item.id)" v-if="item.status==1">取消订单</button>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="order_zi">
				<div class="kunasg">
					您的订单空空的~~
				</div>
			</div>
		</div>
		<div class="bottom_paging">
			<el-pagination class="feye" :background="true" :current-page.sync="pageNo" :page-size="limit" layout="prev, pager, next, jumper"
				:total="total" @current-change="pageCurrentChange" :hide-on-single-page="true"></el-pagination>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				loading:true,
				total:0,//总数量
				pageNo:1,//当前页
				limit:0,//一页多少条
				integralList:[],//积分订单列表
				index:0,
				tabs:['所有订单','审核中','已接受','已发货','已完成','已取消','已驳回']
			}
		},
		created(){
			this.PostintegralOrders();
		},
		methods:{
			addmi(i){
				this.index = i;
				this.pageNo=1;
				this.PostintegralOrders();
			},
			async Postintegralcancel(orders_id){//取消订单
				this.$confirm('您确定要取消订单吗', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
				}).then(async () => {
					let {code} = await this.api.Postintegralcancel({orders_id});
					if(code==200){
						this.$message.success('订单取消成功!');
						this.PostintegralOrders();
					}
				});
			},
			async PostintegralOrders(){
				this.loading = true;
				let status = this.index==0?'':this.index;
				let {code,data} = await this.api.PostintegralOrders({status,page:this.pageNo});
				if(code==200){
					this.integralList = data.data||[];
					this.total = data.total;
					this.limit = data.per_page;
				}
				this.loading = false;
			},
			pageCurrentChange(val) {//分页查询
				this.pageNo = val;
				this.PostintegralOrders();
			},
		}
	}
</script>

<style lang="scss" scoped="scoped">
.order_to{
		margin-top: 30px;
		color: #fff;
		height: 40px;
		background: #005599;
		display: flex;
		align-items: center;
		span:nth-child(1){
			flex: 2;
			text-align: center;
		}
		span:not(:nth-child(1)){
			flex: 1;
			text-align: center;
		}
	}
	.order_zi{
		margin-top: 20px;
		.zi_box{
			height: 160px;
			border: 1px solid #f2f2f2;
			display: flex;
			
			align-items: center;
			color: #333333;
			.zi_download{
				display: flex;
				
			}
			div:nth-child(1) {
				flex: 2;
				text-align: center;
			}
			div:not(:nth-child(1)) {
				flex: 1;
				text-align: center;
			}
			.zi_name{
				height: 100px;
				display: flex;
				flex-direction: column;
				align-items: baseline;
				margin-left: 20px;
				width: 110px;
			}
			.jine{
				// font-size: 24px;
			}
			.zi_btn{
				div{
					flex: 0;
				}
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: space-around;
				height: 100px;
			}
			img{
				width: 100px;
				height: 100px;
				margin-left: 40px;
			}
		}
		.zi_to{
			line-height: 40px;
			// padding-left: 40px;
			height: 40px;
			color: #666;
			// border: 1px dashed #666;
			background: #F2F2F2;
			span{
				margin-left: 40px;
			}
		}
	}
</style>
